/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsetsListToolFilters } from "../funcs/toolsetsListToolFilters.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListToolFiltersResult } from "../models/components/listtoolfiltersresult.js";
import {
  ListToolsetToolFiltersRequest,
  ListToolsetToolFiltersSecurity,
} from "../models/operations/listtoolsettoolfilters.js";
import { unwrapAsync } from "../types/fp.js";
export type ListToolsetToolFiltersQueryData = ListToolFiltersResult;

export function prefetchListToolsetToolFilters(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListToolsetToolFiltersRequest,
  security?: ListToolsetToolFiltersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListToolsetToolFiltersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListToolsetToolFiltersQuery(
  client$: GramCore,
  request: ListToolsetToolFiltersRequest,
  security?: ListToolsetToolFiltersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListToolsetToolFiltersQueryData>;
} {
  return {
    queryKey: queryKeyListToolsetToolFilters({
      slug: request.slug,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function listToolsetToolFiltersQueryFn(
      ctx,
    ): Promise<ListToolsetToolFiltersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(toolsetsListToolFilters(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListToolsetToolFilters(
  parameters: {
    slug: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "toolsets", "listToolFilters", parameters];
}
